import gql from 'graphql-tag'

export const DESLIGAMENTO_QUERY = gql`
  query Desligamento {
    desligamentos {
      id
      motivo
    }
  }
`
